import { render, staticRenderFns } from "./UnlockAsk.vue?vue&type=template&id=06c966e8&scoped=true&"
import script from "./UnlockAsk.vue?vue&type=script&lang=js&"
export * from "./UnlockAsk.vue?vue&type=script&lang=js&"
import style0 from "./UnlockAsk.vue?vue&type=style&index=0&id=06c966e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c966e8",
  null
  
)

component.options.__file = "UnlockAsk.vue"
export default component.exports